import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
// import './CourseTable.css'; // Optional: For custom styles if needed
import plus_icon from "../../../assets/dashboard/plus-icon.svg"
import { getAllCourses, getPolicyById } from '../../../services/Trainer/trainer';
import moment from 'moment';
import { toast } from 'react-toastify';
import logo from '../../../assets/policy/policy-right-logo.svg'
import TopLogo from '../../../assets/policy/policy-top-logo.svg'
import TopLogoicon from '../../../assets/policy/TopLogo-icon.svg'

import iconImage from '../../../assets/policy/Eb-logo-icon.svg'
import { renderDescriptionHtml } from '../../../components/common/renderDescriptionHtml';

const ViewPolicy = ({ courses, onDeleteCourse, onAssignStaff }) => {
  const [policyData, setPolicyData] = useState();

  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const fetchData = async () => {
    setLoading(true)
    const data = await getPolicyById(id);
    if (data) {
      console.log("Staff data >>>", data);
      setPolicyData(data.data);
    }
    setLoading(false)

  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, []);

  return (
    <div className="management-container">
      {
        loading ?
          <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
          :
          <div className="row">
            <div
              className="col-12 col-md-12 col-lg-12 mx-auto position-relative mb-5"
              style={{ textAlign: 'center' }}
            >
              {/* Main Logo */}
              <div
                style={{
                  backgroundColor: '#E9E7E0',
                  borderBottomLeftRadius: '16px',
                  borderBottomRightRadius: '16px',
                  width: '100%',
                  height: '140px', // or any height you want
                }}
              ></div>
              <p
                style={{
                  position: 'absolute',
                  fontSize:'30px',
                  fontWeight:'700',
                  top: '19%',
                  left: '4%',
                  // transform: 'translate(-50%, -50%)',
                  width: '480px', // Adjust size as needed
                  // height: '90px',
                  textAlign:'justify',
                  pointerEvents: 'none',
                }}
              >
                Empowering Beauty with Integrity
                & Clarity
              </p>

              {/* Icon Image on top */}
              <img
                src={TopLogoicon} // Replace with your actual icon image variable or URL
                alt="Center Icon"
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: '8%',
                  transform: 'translate(-50%, -50%)',
                  width: '90px', // Adjust size as needed
                  height: '90px',
                  pointerEvents: 'none',
                }}
              />
            </div>
            <div className="col-8 col-md-8 col-lg-8 mx-auto">
              {policyData && policyData?.description && (

                // <div dangerouslySetInnerHTML={{ __html: policyData.description }} />
                 <div
                  className="post-description"
                  dangerouslySetInnerHTML={{ __html: renderDescriptionHtml(policyData) }}
                />

              )}

            </div>
            <div
              className="col-3 col-md-3 col-lg-3  position-relative"
              style={{ textAlign: 'center' }}
            >
              {/* Main Logo */}
              <img
                src={logo}
                alt="Logo"
                style={{ width: '100%', height: 'auto' }}
              />

              {/* Icon Image on top */}
              <img
                src={iconImage} // Replace with your actual icon image variable or URL
                alt="Center Icon"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  // width: '40px', // Adjust size as needed
                  // height: '40px',
                  pointerEvents: 'none',
                }}
              />
            </div>
          </div>

      }
    </div>

  );
};

export default ViewPolicy;
